export const CUSTOM_FIELDS_SECTION_TITLE = 'Custom Fields';

export const CUSTOM_FIELDS_REQUIRED_ERROR = 'This field is required!';

export const CUSTOM_FIELDS_VALUE_TYPE = {
  TEXT: 'Text',
  NUMBER: 'Number',
  DATE: 'Date',
  BOOLEAN: 'Boolean',
  PERCENTAGE: 'Percentage',
  CURRENCY: 'Currency',
  EMAIL: 'Email',
  PHONE: 'Phone',
  URL: 'Url',
};

export const CUSTOM_FIELDS_VALUE_SOURCE = {
  MANUAL: 'Manual',
  CALCULATED: 'Calculated',
};

export const CUSTOM_FIELDS_TARGET = {
  LOAN: 'Loan',
  BORROWER: 'Borrower',
  PROPERTY: 'Property',
  SUBJECT_PROPERTY: 'SubjectProperty',
  INCOME: 'Income',
  ASSET: 'Asset',
  LIABILITY: 'Liability',
  NBE: 'Nbe',
};

export const CUSTOM_FIELDS_BOOLEAN_STRING = {
  TRUE: 'true',
  FALSE: 'false',
};

export const CUSTOM_FIELDS_VALIDATION_ERROR = {
  EMAIL: 'Please enter a valid email address',
  PHONE: 'Please enter a valid phone number',
  URL: 'Please enter a valid URL',
};

export const CUSTOM_FIELDS_PARTIAL_SAVE_MESSAGE =
  'Main changes were saved, but custom field changes failed to save. Please retry.';
